import {
  Box,
  ChevronSmall,
  convert24HourTo12Hour,
  DeleteIcon,
  DeliveryAssignmentProviderEntity,
  Div,
  EditPenIconRed,
  H5,
  Icon,
  Img,
  P,
  renderMiles,
  renderVDriveIcon,
  renderVDriveProviderName,
  Separator,
  VDriveProvider,
} from '@vgrubs/components';
import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';
import { Collapsible } from '../../VDriveLocation';
import { SelectedFallbackAssignmentProvider } from './SelectedFallbackAssignmentProvider';
import { SelectedOrderProvider } from './SelectedOrderProvider';

export const DeliveryAssignmentProvider = ({
  item,
  setProviders,
  index,
  // availableProviders,
  // bannedProviders = [],
  setEditDeliveryProviderModal,
}: {
  item: DeliveryAssignmentProviderEntity;
  setProviders: Dispatch<SetStateAction<DeliveryAssignmentProviderEntity[]>>;
  index: number;
  availableProviders: VDriveProvider[];
  bannedProviders?: VDriveProvider[];
  setEditDeliveryProviderModal: Dispatch<
    SetStateAction<
      boolean | { item: DeliveryAssignmentProviderEntity; index: number }
    >
  >;
}) => {
  const [collapse, setCollapse] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  const [elementHeight, setElementHeight] = useState(
    ref?.current?.clientHeight
  );
  // const [addProviderFallback, setAddProviderFallback] = useState(false);
  // const [addOrderProvider, setAddOrderProvider] = useState(false);

  const {
    provider,
    startTime,
    endTime,
    distanceMiles,
    fallbackProviders,
    orderProviders,
  } = item;

  useEffect(() => {
    setElementHeight(ref?.current?.clientHeight);
  }, [item]);

  const handleEditItem = () => {
    setEditDeliveryProviderModal({ item, index });
  };

  const handleDeleteItem = () => {
    setProviders((prev) => prev.filter((_, i) => i !== index));
  };

  // const handleAddFallback = (newProvider: VDriveProvider) => {
  //   setProviders((prev) =>
  //     prev.map((p, i) =>
  //       i === index
  //         ? {
  //             ...p,
  //             fallbackProviders: [...(p.fallbackProviders || []), newProvider],
  //           }
  //         : p
  //     )
  //   );
  // };

  // const handleAddOrderProviders = (newProvider: Provider) => {
  //   setProviders((prev) =>
  //     prev.map((p, i) =>
  //       i === index
  //         ? {
  //             ...p,
  //             orderProviders: [...(p.orderProviders || []), newProvider],
  //           }
  //         : p
  //     )
  //   );
  // };

  const handleDeleteFallback = (parentIndex: number, index: number) => {
    setProviders((prev) =>
      prev.map((p, i) =>
        i === parentIndex
          ? {
              ...p,
              orderProviders: p.orderProviders?.filter((_, j) => j !== index),
            }
          : p
      )
    );
  };

  return (
    <Box $flex $justifyCenter $between $column>
      <Div $pointer $flex $alignCenter $between>
        <Div
          $flex
          $alignCenter
          $gap="16px"
          onClick={() => setCollapse((prev) => !prev)}
        >
          <Div $flexNone>
            <Img
              alt=""
              src={renderVDriveIcon(provider)}
              $width="32px"
              $widthSM="32px"
            />
          </Div>
          <H5 $mb="0">{renderVDriveProviderName(provider)}</H5>
        </Div>
        <Div $flex $alignCenter $gap="16px">
          <Icon $size="32" onClick={handleEditItem}>
            <EditPenIconRed />
          </Icon>
          <Icon $size="32" onClick={handleDeleteItem}>
            <DeleteIcon />
          </Icon>
          <Icon
            $rotate={collapse ? '180deg' : '0'}
            onClick={() => setCollapse((prev) => !prev)}
          >
            <ChevronSmall />
          </Icon>
        </Div>
      </Div>
      <Collapsible expanded={collapse} elementHeight={elementHeight}>
        <Div ref={ref} $flex $column $gap="4px">
          <Separator $m="0 0 12px 0" />
          <P $m="0">Distance Condition:</P>
          <H5 $m="0">
            {distanceMiles
              ? `Under ${distanceMiles} ${renderMiles(distanceMiles)}`
              : '-'}
          </H5>
          <Separator $m="12px 0" />
          <P $m="0">Time Condition:</P>
          <H5 $m="0">
            {convert24HourTo12Hour(startTime)} -{' '}
            {convert24HourTo12Hour(endTime)}
          </H5>
          <Separator $m="12px 0" />

          <Div $flex $alignCenter $between $gap="20px">
            <Div
              $flex={
                !(
                  orderProviders === null ||
                  (orderProviders && orderProviders?.length < 1)
                )
              }
              $alignCenter
              $gap="20px"
              $wrap
            >
              <P $m="0">Order Provider Condition:</P>
              {orderProviders === null ||
              (orderProviders && orderProviders?.length < 1) ? (
                <H5 $m="0">-</H5>
              ) : null}
              {orderProviders?.map((fp, i) => (
                <SelectedOrderProvider
                  key={i}
                  provider={fp}
                  handleDelete={() => handleDeleteFallback(index, i)}
                />
              ))}
            </Div>
            {/* <Icon $pointer onClick={() => setAddOrderProvider(true)}>
              <PlusIcon />
            </Icon> */}
          </Div>

          <Separator $m="12px 0" />
          <Div $flex $alignCenter $between $gap="20px">
            <Div
              $flex={
                !(
                  fallbackProviders === null ||
                  (fallbackProviders && fallbackProviders?.length < 1)
                )
              }
              $alignCenter
              $gap="20px"
              $wrap
            >
              <P $m="0">Fallback: </P>
              {fallbackProviders === null ||
              (fallbackProviders && fallbackProviders?.length < 1) ? (
                <H5 $m="0">-</H5>
              ) : null}
              {fallbackProviders?.map((fp, i) => (
                <SelectedFallbackAssignmentProvider
                  key={i}
                  provider={fp}
                  index={i}
                  parentIndex={index}
                  setProviders={setProviders}
                />
              ))}
            </Div>
            {/* <Icon $pointer onClick={() => setAddProviderFallback(true)}>
              <PlusIcon />
            </Icon> */}
          </Div>
        </Div>
      </Collapsible>
      {/* <AddAssignmentProvider
        isOpen={addProviderFallback}
        setIsOpen={setAddProviderFallback}
        addFunction={(provider) =>
          handleAddFallback(provider as VDriveProvider)
        }
        header="Add Fallback Provider"
        alreadyAddedProviders={fallbackProviders}
        availableProviders={availableProviders}
        bannedProviders={[...bannedProviders, provider]}
      />
      <AddAssignmentProvider
        isOpen={addOrderProvider}
        setIsOpen={setAddOrderProvider}
        addFunction={(provider) =>
          handleAddOrderProviders(provider as Provider)
        }
        header="Add Order Provider"
        orderProvider
        alreadyAddedProviders={orderProviders}
      /> */}
    </Box>
  );
};
